import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class TabNavigationService {
  private eventSource = new Subject<{ type: string; data?: any }>();

  public event = this.eventSource.asObservable();

  emitEvent(data: { type: string; data?: any }): void {
    this.eventSource.next(data);
  }
}
